export class DrawingService {
    private drawings: any;
    private viewer: any;

    constructor() {
        this.drawings = [];
        this.viewer = window.viewer;
    }

    addDrawing(drawing: any) {
        this.drawings.push(drawing);
        this.viewer.scene.dispatchEvent({
            type: 'drawing_added',
            scene: this,
            drawing: drawing,
        });
    }

    removeDrawing(drawing: any) {
        let index = this.drawings.indexOf(drawing);
        if (index > -1) {
            this.drawings.splice(index, 1);
            this.viewer.scene.dispatchEvent({
                type: 'drawing_removed',
                scene: this,
                drawing: drawing,
            });
        }
    }

    removeAllDrawings() {
        while (this.drawings.length > 0) {
			this.removeDrawing(this.drawings[0]);
		}
    }

    getDrawings() {
        return this.drawings;
    }
}
